import { Component, OnInit } from '@angular/core';
// import { trigger, state, style , animate, transition, query, stagger  } from '@angular/animations';
@Component({
  selector: 'app-beta',
  templateUrl: './beta.component.html',
  styleUrls: ['./beta.component.css']
})
export class BetaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }


}
